import type { RoundStep } from "../core/round";

export function shouldPlayHit(step: Pick<RoundStep, "result">): boolean {
    return step.result?.used === true && step.result.hit === true;
}

/** 防止回看分叉或组件卸载后，旧动画异步回调推进新回合。 */
export class ReplayController {
    private generation = 0;

    cancel() {
        this.generation++;
    }

    async run<T>(
        steps: readonly T[],
        options: {
            isCurrent: () => boolean;
            play: (step: T) => Promise<void>;
            commit: () => void;
            settle: () => Promise<void>;
            finish: () => void;
        },
    ): Promise<void> {
        const generation = ++this.generation;
        const current = () => generation === this.generation && options.isCurrent();
        for (const step of steps) {
            if (!current()) return;
            await options.play(step);
            if (!current()) return;
            options.commit();
            await options.settle();
        }
        if (current()) options.finish();
    }
}
